export const testNetProviderUrl = 'https://testnet.vote-chain.com';
export const mainNetProviderUrl = 'https://mainnet.vote-chain.com';
